export default "__VITE_ASSET__Cv2j1tEL__"